import React from 'react'
import intl from 'react-intl-universal'

const StepBar = () => (
  <div className="container-sm text-center signup-steps m-b-md">
    <div className="signup-step text-center active">
      <div className="spot spot-sm spot-white " />
      <div className="signup-step-name">{intl.get('account.application')}</div>
    </div>
    <div className="signup-step text-center">
      <div className="spot spot-sm spot-white spot-white-faded" />
      <div className="signup-step-name">{intl.get('done')}</div>
    </div>
  </div>
)

export default StepBar
